import { c as _c } from "react/compiler-runtime";
import { Button, Heading, HStack, VStack } from '@chakra-ui/react';
import { AppPanelToggleButton } from '@src/components/sco/AppLayout/Panel/AppPanelToggleButton.tsx';
import { AppLayoutToolbar } from '@src/components/sco/AppLayout/Toolbar/AppLayoutToolbar.tsx';
import { RequestsGrid } from '@src/components/sco/Requests/RequestsGrid';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import { parseAsArrayOf, parseAsString, useQueryState } from 'nuqs';
import React from 'react';
type RequestBrowseProps = {};
export const RequestBrowse: React.FC<RequestBrowseProps> = props => {
  const $ = _c(10);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = parseAsArrayOf(parseAsString);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [requestTypeKeys] = useQueryState("requestTypeKeys", t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = parseAsArrayOf(parseAsString);
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [compensationTypeKeys] = useQueryState("compensationTypeKeys", t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = parseAsArrayOf(parseAsString);
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const [tagTitles] = useQueryState("tagTitles", t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <HStack><AppPanelToggleButton panelId="requests-nav" /><Heading size="sm">Browse Requests</Heading></HStack>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <AppLayoutToolbar><HStack justify="space-between" width="full">{t3}<Button asChild={true}><NextLink href="/requests/start">Create Request</NextLink></Button></HStack></AppLayoutToolbar>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = ["published"];
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== compensationTypeKeys || $[7] !== requestTypeKeys || $[8] !== tagTitles) {
    t6 = <VStack width="full">{t4}<VStack align="stretch" gap={4} marginX="auto" maxWidth="container.xl" padding={6}><RequestsGrid allowLoadMore={true} variables={{
          publishStatusKeys: t5,
          compensationTypeKeys,
          groupRequestTypeKeys: requestTypeKeys,
          tagTitles
        }} /></VStack></VStack>;
    $[6] = compensationTypeKeys;
    $[7] = requestTypeKeys;
    $[8] = tagTitles;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
};